import loadingGif from "@assets/sales-v3-chart-loading.gif";

export const PendingMediaPlan = () => {
  return (
    <div className="flex-center h-[790px] font-semibold">
      <div className="bg-v2-primary border border-v2-secondary rounded-lg p-10 w-[40rem] text-center">
        <img className="h-96 mx-auto" src={loadingGif} alt="loading gif" />
        Please allow approximately 1 hour for us to build your model. <br />
        You will then be ready to see Model insights on the "View Incremental
        ROAS/CAC" tab.
      </div>
    </div>
  );
};
